module.exports = __webpack_public_path__ + "static/media/Post3.a0375177.png";